export const ATTRACTIONS_LOCATIONS = {
  'Autopia, presented by Avis': {
    longitude: 2.778797,
    latitude: 48.873417
  },
  'Le Pays des Contes de Fées, presented by Vittel': {
    longitude: 2.774483,
    latitude: 48.87519
  },
  '"it\'s a small world"': {
    longitude: 2.776084,
    latitude: 48.87469
  },
  'Adventure Isle': {
    longitude: 2.77316,
    latitude: 48.872736
  },
  'Alice\'s Curious Labyrinth': {
    longitude: 2.774518,
    latitude: 48.874461
  },
  'Big Thunder Mountain': {
    longitude: 2.774787,
    latitude: 48.871528
  },
  'Blanche-Neige et les Sept Nains': {
    longitude: 2.775298,
    latitude: 48.873445
  },
  'Buzz Lightyear Laser Blast': {
    longitude: 2.777947,
    latitude: 48.87343
  },
  'Casey Jr. – le Petit Train du Cirque': {
    longitude: 2.774151,
    latitude: 48.875176
  },
  'Disneyland Railroad': {
    longitude: 2.779071,
    latitude: 48.870821
  },
  'Disneyland Railroad Discoveryland Station': {
    longitude: 2.778446,
    latitude: 48.874733
  },
  'Disneyland Railroad Fantasyland Station': {
    longitude: 2.773755,
    latitude: 48.874647
  },
  'Disneyland Railroad Frontierland Depot': {
    longitude: 2.772255,
    latitude: 48.870246
  },
  'Dumbo the Flying Elephant': {
    longitude: 2.774606,
    latitude: 48.874152
  },
  'Indiana Jones™ and the Temple of Peril': {
    longitude: 2.772029,
    latitude: 48.872429
  },
  'La Cabane des Robinson': {
    longitude: 2.773744,
    latitude: 48.872336
  },
  'La Galerie de la Belle au Bois Dormant': {
    longitude: 2.776212,
    latitude: 48.873101
  },
  'La Tanière du Dragon': {
    longitude: 2.775918,
    latitude: 48.87308
  },
  'Le Carrousel de Lancelot ': {
    longitude: 2.775168,
    latitude: 48.873908
  },
  'Le Passage Enchanté d\'Aladdin': {
    longitude: 2.775416,
    latitude: 48.872441
  },
  'Les Mystères du Nautilus': {
    longitude: 2.779553,
    latitude: 48.873432
  },
  'Les Voyages de Pinocchio': {
    longitude: 2.775157,
    latitude: 48.873545
  },
  'Mad Hatter\'s Tea Cups': {
    longitude: 2.775025,
    latitude: 48.874365
  },
  'Meet Mickey Mouse': {
    longitude: 2.77392,
    latitude: 48.874422
  },
  'Mickey\'s PhilharMagic': {
    longitude: 2.779698,
    latitude: 48.87456
  },
  'Orbitron®': {
    longitude: 2.778457,
    latitude: 48.873486
  },
  'Peter Pan\'s Flight': {
    longitude: 2.77408,
    latitude: 48.873838
  },
  'Phantom Manor': {
    longitude: 2.776827,
    latitude: 48.870977
  },
  'Pirates of the Caribbean': {
    longitude: 2.773381,
    latitude: 48.873493
  },
  'Princess Pavilion': {
    longitude: 2.775558,
    latitude: 48.874745
  },
  'Star Tours: The Adventures Continue*': {
    longitude: 2.778782,
    latitude: 48.874677
  },
  'Star Wars Hyperspace Mountain': {
    longitude: 2.778863,
    latitude: 48.873651
  },
  'Thunder Mesa Riverboat Landing': {
    longitude: 2.776563,
    latitude: 48.871173
  },
  'Welcome to Starport: A Star Wars Encounter': {
    longitude: 2.778952270746231,
    latitude: 48.874543615495014
  },
  'Main Street Vehicles': {
    longitude: 2.778946,
    latitude: 48.871327
  },
  'Rustler Roundup Shootin\' Gallery': {
    longitude: 2.775611,
    latitude: 48.871546
  },
  'Pirates\' Beach': {
    longitude: 2.773771,
    latitude: 48.87274
  },
  'Pirate Galleon': {
    longitude: 2.773621,
    latitude: 48.872927
  },
  'Disneyland Railroad Main Street Station': {
    longitude: 2.77909,
    latitude: 48.870814
  },
  'Blanche-Neige et les Sept Nains®': {
    longitude: 2.775298,
    latitude: 48.873445
  },
  'Frontierland Playground': {
    longitude: 2.774223,
    latitude: 48.870336
  },
  // Spectacles
  'Disney Stars on Parade': {
    longitude: 2.77663,
    latitude: 48.87271
  },
  'Disney Illuminations': {
    longitude: 2.77611,
    latitude: 48.87318
  },
  'Disney Electrical Sky Parade': {
    longitude: 2.77611,
    latitude: 48.87318
  },
  'The Lion King: Rhythms of the Pride Lands': {
    longitude: 2.77383,
    latitude: 48.87062
  },
  'Million Splash Color': {
    longitude: 2.77663,
    latitude: 48.87271
  },
  'A Million Splashes of Colour': {
    longitude: 2.77663,
    latitude: 48.87271
  }
};